import React, { FC, memo, useCallback, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { SectionContainer } from 'containers/SectionContainer'
import { InnerContainer } from 'containers/InnerContainer'
import { TitleSection } from 'components/TitleSection'

import { ButtonMUI } from 'components/ButtonMUI'
import { TitleBottomSection } from 'components/TitleBottomSection'
import { ImagesPalette } from 'components/ImagesPalette'

import { staticMultimedia } from 'utils'

import styles from './styles.module.scss'


interface IProps {
}

const imagesPalette = [
  [staticMultimedia.PCSDKImage1, staticMultimedia.PCSDKImage2],
  [staticMultimedia.PCSDKImage3, staticMultimedia.PCSDKImage4, staticMultimedia.PCSDKImage5],
  [staticMultimedia.PCSDKImage6, staticMultimedia.PCSDKImage7],
  [staticMultimedia.PCSDKImage8, staticMultimedia.PCSDKImage9, staticMultimedia.PCSDKImage10]
]

const PlayCanvasSection: FC<IProps> = props => {
  return (
    <SectionContainer>
      <InnerContainer style={{ height: '100%', alignItems: 'stretch', borderBottom: '1px solid white' }}>
        <div className={styles.playCanvasContainer}>
          <div className={styles.contentBlock}>
            <div className={styles.descriptionBlock}>
              <TitleSection title={'PlayCanvas SDK:'}
                            subTitle={'Craft Your Own Web Worlds'}/>
              <div className={styles.descriptionBlockInner}>
                <img src={staticMultimedia.somniumWebWorldsLogo}
                     className={styles.somniumWorldsLogo} alt='WebWorldsLogo'/>
                <div className={styles.description}>
                  PlayCanvas is a web-based 3D game engine and development platform. It enables the creation of
                  interactive 3D content directly in a web browser.
                  <br/><br/>
                  With PlayCanvas, users can build, design, and script immersive experiences, animations, and
                  simulations. Somnium Space utilizes PlayCanvas technology to empower parcel owners to craft their own
                  unique web worlds within the virtual reality metaverse.
                  <br/><br/>
                  These worlds, accessible through parcels, allow users to design and share their creative visions while
                  utilizing PlayCanvas' tools for scripting, asset management, and collaboration.
                  <br/><br/>
                  Just as PlayCanvas enables web-based 3D content creation, Somnium Space leverages it to empower parcel
                  owners to build and share their own virtual spaces seamlessly.
                </div>
              </div>
            </div>

            <div className={styles.imagesBlock}>
              <ImagesPalette palette={imagesPalette}/>
            </div>

          </div>

          <div className={styles.bottomBlock}>
            <TitleBottomSection
              title={'Transform Your WEB World with the PlayCanvas SDK'}
              subTitle={'This powerful toolkit empowers you to sculpt immersive web-based worlds within Somnium Space. Seamlessly integrate interactive elements, dynamic visuals, and engaging experiences to captivate visitors. Unleash your imagination and bring your virtual dreams to life using the PlayCanvas SDK.'}/>
            <div className={styles.rightBox}>
              <ButtonMUI styleType={'white'}
                         onClick={() => {
                           window.open('https://gitlab.com/somnium-space-public/somnium-space-web-worlds-alpha', '_blank', 'noopener,noreferrer')
                         }}
                         type="button"
                         sx={{
                           '&&': {
                             width: '225px',
                             padding: '6px',
                             height: '60px',
                             borderRadius: '30px'
                           }
                         }}>Use PlayCanvas SDK</ButtonMUI>
            </div>
          </div>

        </div>
      </InnerContainer>
    </SectionContainer>
  )
}

export default memo(PlayCanvasSection)
